import { render } from "./chat-view.vue?vue&type=template&id=f56dae10"
import script from "./chat-view.vue?vue&type=script&lang=js"
export * from "./chat-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__